import Accordion from '@/common/components/Accordion'
import { BranchConsumptionRestriction } from '@/features/company/components/Profile/ConsumptionRestriction/BranchConsumptionRestriction'
import { ProductCategoryConsumptionRestriction } from '@/features/company/components/Profile/ConsumptionRestriction/ProductCategoryConsumptionRestriction'
import { RestrictionData } from '@/features/company/types/company.type'

export const ConsumptionRestriction = ({ restriction }: { restriction?: RestrictionData }) => {
  return (
    <Accordion
      name="consumption_restriction"
      head={<p className="text-sm">Restrição de consumo</p>}
      body={
        <div className="flex flex-col gap-4">
          <BranchConsumptionRestriction restriction={restriction} />

          {Number(restriction?.product_category_restrictions?.length) > 0 && (
            <ProductCategoryConsumptionRestriction
              productCategoryRestrictions={restriction?.product_category_restrictions || []}
            />
          )}
        </div>
      }
    />
  )
}
